import { render, staticRenderFns } from "./MetricBlock.vue?vue&type=template&id=3b309ed2&scoped=true&"
import script from "./MetricBlock.js?vue&type=script&lang=js&"
export * from "./MetricBlock.js?vue&type=script&lang=js&"
import style0 from "./MetricBlock.css?vue&type=style&index=0&id=3b309ed2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b309ed2",
  null
  
)

export default component.exports